export interface VCardContact {
  fullName?: string;
  firstName?: string;
  lastName?: string;
  organization?: string;
  title?: string;
  email?: string[];
  phone?: string[];
  address?: string[];
  url?: string[];
  note?: string;
  birthday?: string;
  photo?: string;
}

export function parseVCF(content: string): VCardContact {
  const contact: VCardContact = {};

  // Split content into lines and handle line folding
  const lines = content.split(/\r?\n/).reduce((acc: string[], line) => {
    // Handle line folding (lines starting with space or tab)
    if (line.startsWith(" ") || line.startsWith("\t")) {
      if (acc.length > 0) {
        acc[acc.length - 1] += line.substring(1);
      }
    } else {
      acc.push(line);
    }
    return acc;
  }, []);

  for (const line of lines) {
    if (!line || line.startsWith("#")) continue;

    const colonIndex = line.indexOf(":");
    if (colonIndex === -1) continue;

    const field = line.substring(0, colonIndex).toUpperCase();
    const value = line.substring(colonIndex + 1);

    switch (field) {
      case "FN":
        contact.fullName = value;
        break;
      case "N":
        const nameParts = value.split(";");
        if (nameParts.length >= 2) {
          contact.lastName = nameParts[0];
          contact.firstName = nameParts[1];
        }
        break;
      case "ORG":
        contact.organization = value;
        break;
      case "TITLE":
        contact.title = value;
        break;
      case "EMAIL":
        if (!contact.email) contact.email = [];
        contact.email.push(value);
        break;
      case "TEL":
        if (!contact.phone) contact.phone = [];
        contact.phone.push(value);
        break;
      case "ADR":
        if (!contact.address) contact.address = [];
        // Format address by splitting on semicolons and filtering out empty parts
        const addressParts = value.split(";").filter((part) => part.trim());
        const formattedAddress = addressParts.join(", ");
        contact.address.push(formattedAddress);
        break;
      case "URL":
        if (!contact.url) contact.url = [];
        contact.url.push(value);
        break;
      case "NOTE":
        contact.note = value;
        break;
      case "BDAY":
        contact.birthday = value;
        break;
      case "PHOTO":
        contact.photo = value;
        break;
    }
  }

  return contact;
}

export async function parseVCFFromFile(file: File): Promise<VCardContact> {
  const content = await file.text();
  return parseVCF(content);
}

export async function parseVCFFromUrl(url: string): Promise<VCardContact> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch VCF file: ${response.statusText}`);
  }
  const content = await response.text();
  return parseVCF(content);
}
